import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import api from '../../../app/api/api';
import { Order } from '../../../app/data/models/orders/order';

export interface OrderDetailsState {
  order: Order | null;
  status: string;
}

const initialState: OrderDetailsState = {
  order: null,
  status: 'idle',
};

export const fetchOrderDetailsAsync = createAsyncThunk<
  Order,
  { restaurantId: string; orderId: string }
>('orderDetails/fetchOrderDetails', async ({ restaurantId, orderId }) => {
  return await api.Order.details(restaurantId, orderId);
});

export const orderDetailsSlice = createSlice({
  name: 'orderDetails',
  initialState,
  reducers: {
    clearOrderDetails: (state) => {
      state.order = null;
      state.status = 'idle';
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchOrderDetailsAsync.pending, (state) => {
        state.status = 'pending';
      })
      .addCase(fetchOrderDetailsAsync.fulfilled, (state, action) => {
        state.order = action.payload;
        state.status = 'idle';
      })
      .addCase(fetchOrderDetailsAsync.rejected, (state) => {
        state.status = 'failed';
      });
  },
});

export const { clearOrderDetails } = orderDetailsSlice.actions;
